import * as React from 'react';
import { observer, inject } from 'mobx-react';
import * as classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { IAppOnlyStore } from 'stores/AllStores';
import { BusinessPartnerContent } from '.';

// Styles
const s = require('./BusinessPartnerSlider.css');

// Props
interface IBusinessPartnerSliderProps extends IAppOnlyStore {
  show: boolean;
}

// Component
@inject('store')
@observer
export class BusinessPartnerSlider extends React.Component<
  IBusinessPartnerSliderProps,
  {}
> {
  constructor(props: IBusinessPartnerSliderProps) {
    super(props);
  }

  private get animationTime(): number {
    return 500;
  }

  public render() {
    const { newRequest } = this.props.store.businessPartner;

    return (
      <CSSTransitionGroup
        component="div"
        className={classNames(s.slider, {
          [s.show]: this.props.show,
        })}
        transitionName="slide"
        transitionAppear={true}
        transitionEnter={true}
        transitionLeave={true}
        transitionAppearTimeout={this.animationTime}
        transitionEnterTimeout={this.animationTime}
        transitionLeaveTimeout={this.animationTime}
      >
        {this.props.show && (
          <div className={s.shade} key="busines-partner">
            <div className={s.pane}>
              <BusinessPartnerContent status={newRequest.status} />
            </div>
          </div>
        )}
      </CSSTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.tsx